<template>
  <div class="">


       <ValidationObserver v-slot="{ handleSubmit }">
      <CForm @submit.prevent="handleSubmit(onPricingFormSubmit)">
        <CCard>
          <CCardHeader class="card-header grey-header d-flex">
            <div class="row flex-flow-column">
              <div class="col">
                <strong v-if="selectedPricing != null">{{
                  $t("createPricing.updatePricing")
                }}</strong>

                <strong v-else>{{ $t("createPricing.createPricing") }}</strong>
              </div>
              <p class="desc">
                {{ $t("createPricing.desc") }}
              </p>
            </div>
          </CCardHeader>
          <CCardBody>
            <section class="card-body">
              <div>
                <strong>
                  {{ $t("simplePricing.pricingInfo") }}
                </strong>
              </div>
              <CRow>
                <cTextInputComponent
                  :label="$t('simplePricing.pricingName')"
                  :placeholder="$t('simplePricing.pricingNamePl')"
                  v-model="pricing.name"
                  rules="noInitialSpace|required|max:30"
                >
                </cTextInputComponent>
              </CRow>

              <CRow>
                <CCol>
                  <div>
                    <span>
                      {{ $t("simplePricing.travel") }}
                    </span>
                  </div>
                  <div class="ext-date-wrapper box-shadow left">
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="date"
                      rules="required"
                    >
                      <v-md-date-range-picker
                        v-model="pricing.travelPeriodFrom"
                        :ref="''"
                        :autoApply="true"
                        :showYearSelect="true"
                        :allowPastPresets="false"
                        :disableBefore="new Date().toString()"
                        @change="onChangeDate"
                      >
                        <template slot="input">
                          <datePickerInput
                            :fromDate="
                              pricing.travelPeriodFrom
                                ? pricing.travelPeriodFrom
                                : null
                            "
                            :toDate="
                              pricing.travelPeriodTo
                                ? pricing.travelPeriodTo
                                : null
                            "
                            :fromLabel="$t('simplePricing.from')"
                            :toLabel="$t('simplePricing.to')"
                          />
                        </template>
                      </v-md-date-range-picker>
                      <div
                        v-if="errors && errors[0]"
                        class="invalid-feedback icon"
                      >
                        <span>
                          {{ errors[0] }}
                        </span>
                      </div>
                    </ValidationProvider>
                  </div>
                </CCol>
              </CRow>
            </section>
            <section class="card-body">
              <CRow>
                <div class="subtitile-details">
                  <CCol class="d-flex">
                    <p class="v-center">
                      <label>{{ $t("simplePricing.airlines") }}</label>
                    </p>
                  </CCol>

                  <div class="col">
                    <ValidationProvider :rules="'required'" v-slot="{ errors }">
                      <multiselect
                        v-if="lsAirlines && lsAirlines.length != null"
                        v-model="pricing.airlines"
                        label="airline_name"
                        :allow-empty="true"
                        :options="lsAirlines"
                        :track-by="'airline_code'"
                        :showLabels="false"
                        :placeholder="$t('simplePricing.selectAirlines')"
                        :multiple="
                          pricing.airlines &&
                          pricing.airlines.length &&
                          pricing.airlines.some(
                            (airline) => airline.airline_code == null
                          )
                            ? false
                            : true
                        "
                        @input="onAirlineChange"
                      >
                        <template #noOptions>
                          {{
                            pricing.airlines && pricing.airlines.length == 0
                              ? $t("simplePricing.noAirlines")
                              : $t("simplePricing.listEmpty")
                          }}
                        </template>
                        <template #noResult>
                          <strong> {{ $t("simplePricing.listEmpty") }}</strong>
                        </template>
                      </multiselect>
                      <div
                        v-if="errors && errors[0]"
                        class="invalid-feedback icon"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </ValidationProvider>
                  </div>
                </div>
              </CRow>
            </section>

            <CRow>
              <div class="subtitile-details">
                <CCol class="d-flex">
                  <p class="v-center">
                    <label>{{ $t("simplePricing.sector") }}</label>
                  </p>
                </CCol>

                <div class="col">
                  <ValidationProvider :rules="'required'" v-slot="{ errors }">
                    <multiselect
                      v-if="pricing && lsSectors && lsSectors.length != null"
                      v-model="pricing.sectorList"
                      label="value"
                      :allow-empty="true"
                      :options="lsSectors"
                      :track-by="'value'"
                      :showLabels="false"
                      :placeholder="$t('simplePricing.selectSector')"
                      :multiple="
                        pricing.sectorList &&
                        pricing.sectorList.length &&
                        pricing.sectorList.some(
                          (sector) =>
                            sector.value == DEFAULT_DROPDOWN_STATUS.ALL
                        )
                          ? false
                          : true
                      "
                      @input="onSectorsChange"
                    >
                      >
                      <template #noOptions>
                        {{
                          pricing.airlines && pricing.airlines.length == 0
                            ? $t("simplePricing.noAirlines")
                            : $t("simplePricing.listEmpty")
                        }}
                      </template>
                      <template #noResult>
                        <strong>
                          {{
                            pricing.airlines && pricing.airlines.length == 0
                              ? $t("simplePricing.noAirlines")
                              : $t("simplePricing.listEmpty")
                          }}</strong
                        >
                      </template>
                    </multiselect>
                    <div
                      v-if="errors && errors[0]"
                      class="invalid-feedback icon"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
            </CRow>

            <CRow>
              <div class="subtitile-details">
                <CCol class="d-flex">
                  <p class="v-center">
                    <label>{{ $t("simplePricing.bookingClass") }}</label>
                  </p>
                </CCol>

                <div class="col">
                  <ValidationProvider :rules="'required'" v-slot="{ errors }">
                    <multiselect  style="text-transform:uppercase"
                      v-if="lsClasses && lsClasses.length != null"
                      v-model="pricing.bookingClassList"
                      :allow-empty="true"
                      :options="lsClasses"
                      :showLabels="false"
                      :placeholder="$t('simplePricing.bookingClassPl')"
                      :multiple="
                        pricing.bookingClassList &&
                        pricing.bookingClassList.length &&
                        pricing.bookingClassList.some(
                          (bookingClass) =>
                            bookingClass == DEFAULT_DROPDOWN_STATUS.ALL
                        )
                          ? false
                          : true
                      "
                      @input="onBookingClassChange"
                      :tag-placeholder="$t('simplePricing.addTag')"
                      :taggable="
                        pricing.airlines && pricing.airlines.length
                          ? true
                          : false
                      "
                      @tag="addBookingClass"
                    >
                      <template #noOptions>
                        {{
                          pricing.airlines && pricing.airlines.length == 0
                            ? $t("simplePricing.noAirlines")
                            : $t("simplePricing.listEmpty")
                        }}
                      </template>
                      <template #noResult>
                        <strong>
                          {{
                            pricing.airlines && pricing.airlines.length == 0
                              ? $t("simplePricing.noAirlines")
                              : $t("simplePricing.listEmpty")
                          }}</strong
                        >
                      </template>
                    </multiselect>
                    <div
                      v-if="(errors && errors[0]) ||classAlert"
                      class="invalid-feedback icon"
                    >
                      <span>{{ errors[0] }} {{classAlert}}</span>
                    </div>
                  </ValidationProvider>
                </div>
              </div>
            </CRow>

            <CCardBody class="pb-0px">
              <div class="wrap">
                <div class="des"></div>
                <div class="options-wrap">
                  <div class="option pricing_type">
                    <label for="" class="title">Pricing Type:</label>
                    <div
                      v-if="lsPricingTypes && lsPricingTypes.length"
                      class="input-wrap row"
                    >
                      <div
                        class="right d-flex"
                        v-for="(pType, index) in lsPricingTypes"
                        :key="'pt' + index"
                      >
                        <cRadioButton
                          v-model="pricing.pricingType"
                          class="radio-inline"
                          :name="pType.name"
                          :value="pType.code"
                          :label="pType.name"
                          :inline="true"
                          v-on:input="onPricingTypeChange(pType)"
                          :selValue="pricing.pricingType"
                        />
                        <span
                          v-if="pType.value == PRICING_VALUE.PERCENTAGE"
                          class="d-flex align-item-center"
                        >
                          <cHelpTip
                            :content="$t('helpTip.createPricingPercntBase')"
                          ></cHelpTip>
                        </span>
                        <span
                          v-if="pType.value == PRICING_VALUE.FIXED_AMOUNT"
                          class="d-flex align-item-center"
                        >
                          <cHelpTip
                            :content="$t('helpTip.createPricingFixd')"
                          ></cHelpTip>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="option">
                    <label for="" class="title">{{
                      $t("createPricing.applyPricing")
                    }}</label>
                    <div
                      v-if="lsPricingApplicables && lsPricingApplicables.length"
                      class="input-wrap row"
                    >
                      <div
                        class="right"
                        v-for="(pType, index) in lsPricingApplicables"
                        :key="'pa' + index"
                      >
                        <cRadioButton
                          v-if="pricing.applicableTo"
                          v-model="pricing.applicableTo"
                          class="radio-inline"
                          :disabled="
                            pricing.pricingType.value ==
                              PRICING_VALUE.PERCENTAGE &&
                              pType.value == PRICING_VALUE.PER_PASSENGER
                          "
                          :name="pType.name"
                          :value="pType.code"
                          :label="pType.name"
                          :inline="true"
                          v-on:input="onPricingApplicableToChange(pType)"
                          :selValue="pricing.applicableTo"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="option">
                    <label
                      v-if="
                        pricing.pricingType.value == PRICING_VALUE.PERCENTAGE
                      "
                      for=""
                      class="title"
                      >{{ $t("createPricing.percentage") }}
                      <span>{{ " % " }}</span>
                    </label>
                    <label v-else for="" class="title">
                      {{ $t("createPricing.amount") }}
                    </label>
                    <div v-if="pricing && pricing.currencies" class="input">
   
                      <cCurrencyBoxes
                        :currItems="pricing.currencies"
                        :rules="
                                'required|onlynumber' +( (pricing.pricingType.value ==
                          PRICING_VALUE.PERCENTAGE)
                            ? '|max_val:100'
                            : '')
                        "
                        :isPercentage="
                          pricing.pricingType.value == PRICING_VALUE.PERCENTAGE
                            ? true
                            : false
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
              <CRow> </CRow>

              <CRow>
                <span> </span>
              </CRow>
            </CCardBody>
          </CCardBody>

          <CCardFooter class="d-flex justify-content-end">
            <CRow class="d-flex justify-content-end">
              <CCol>
                <CButton @click="navToManagePricing()" color="danger">
                  {{ $t("createPricing.goBack") }}
                </CButton>
              </CCol>
              <CCol style="white-space: nowrap">
                <!-- <CButton
              class="btn action-c-btn btn-success"
        
              type="submit"
            >
              {{ $t("createPricing.updatePricing") }}
            </CButton> -->

                <CButton class="btn action-c-btn btn-success" type="submit">
                  {{
                    selectedPricing
                      ? $t("createPricing.updatePricing")
                      : $t("createPricing.createPricing")
                  }}
                </CButton>
              </CCol>
            </CRow>
          </CCardFooter>
        </CCard>
      </CForm>
    </ValidationObserver>
    <cAlertModal
      v-if="showAlertModal"
      :key="'alert'"
      :show="showAlertModal"
      :buttonList="getAlertModalBtn()"
      :status="1"
      :desc="
        selectedPricing
          ? $t('createPricing.updateStatus')
          : $t('createPricing.createStatus')
      "
    >
    </cAlertModal>
  </div>
</template>

<script>
import cDropDown from "../../../components/form/cDropDown";
import router, { goBack, navigate } from "../../../router/index";
import apiCreateSimplePricing from "../../../services/apiCreateSimplePricing";
import apiUpdateSimplePricing from "../../../services/apiUpdateSimplePricing";
import { mapGetters, mapActions } from "vuex";
import {
  PATHNAME,
  COMPONENT_NAME,
  DEFAULT_DROPDOWN_STATUS,
  DATE_TIME_FORMAT,
  ALERT_MODAL_STATUS,
  ORDER,
  PRICING_VALUE,
} from "../../../util/constants";

import Logger from "../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../config/API_DATA";

import multiselect from "vue-multiselect";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  cloneDeep,
  cloneData,
} from "../../../util/util";
import BaseConfiguration from "../../../config/base.js";
import cPaginationLenOption from "../../../components/dataTable/cPaginationLenOption";
import cFullScreen from "../../../components/cFullScreen";
import cManageColumns from "../../../components/dataTable/cManageColumns";
import cTable from "../../../components/dataTable/cTable";
import cAlertModal from "../../../components/form/cAlertModal";
import cTextInputComponent from "../../../components/form/cTextInputComponent.vue";
import apiGetCitiesforHotel from "../../../services/apiGetCitiesforHotel.js";
import apiGetAirline from "../../../services/apiGetAirline";
import apiGetPricingSectorsClasses from "../../../services/apiGetPricingSectorsClasses";
import apiGetOrgCurrencyLs from "../../../services/apiGetOrgCurrencyLs";
import datePickerInput from "../../../components/datePicker/datePickerInput";
import { VMdDateRangePicker } from "material-vue-date-picker";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import cRadioButton from "../../../components/form/cRadioButton";
import cHelpTip from "../../../components/cHelpTip";
import cCurrencyBoxes from "../../../components/currency/cCurrencyBoxes";
export default {
  name: COMPONENT_NAME.CREATE_SIMPLE_PRICING,

  components: {
    cTextInputComponent,
    VMdDateRangePicker,
    cAlertModal,
    datePickerInput,
    ValidationProvider,
    ValidationObserver,
    multiselect,
    cHelpTip,
    cRadioButton,
    cCurrencyBoxes,
  },

  data: () => {
    return {
      lsAirlines: [],
      lsSectors: [],
      lsClasses: [],
      lsPricingTypes: [],
      lsPricingApplicables: [],
      currencyList: [],
      showAlertModal: false,
      classAlert:null,
      pricing: {
        tierId: null,
        airlines: [],
        name: null,
        travelPeriodFrom: null,
        travelPeriodTo: null,
        sectorList: [],
        bookingClassList: [],
        upDown: "UP",
        applicableTo: "PERPAX",
        pricingType: "PERC",

        currencies: null,
      },
    };
  },
  computed: {
    ...mapGetters("sCreatePricing", {
      selectedPricing: "GET_SEL_MARKUP_PRICING",
      selectedPricingTier: "GET_SELECTED_TIER",
      GET_SEL_TIER_NAME: "GET_SEL_TIER_NAME",
    }),
    ...mapGetters("sCAirLine", { GET_ALL_AIRLINE_RES: "GET_ALL_AIRLINE_RES" }),
    ...mapGetters("sCurrencyLs", {
      GET_ORG_CURRENCY_RES: "GET_ORG_CURRENCY_RES",
    }),

    PRICING_VALUE: function() {
      return PRICING_VALUE;
    },

    DEFAULT_DROPDOWN_STATUS: function() {
      return DEFAULT_DROPDOWN_STATUS;
    },
  },

  methods: {
    getAlertModalBtn() {
      return [
        {
          name: this.$t("createPricing.ok"),
          func: this.navToManagePricing,
        },
      ];
    },

    toggleAlertModal() {
      try {
        if (BaseConfiguration.isDebug) console.log("toggleAlertModal");
        this.showAlertModal = !this.showAlertModal;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.filename,
          "error in toggleAlertModal",
          err.toString(),
          "toggleAlertModal",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onSectorsChange(pSectorsList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onSectorsChange");
        this.handleDropDownOptions(pSectorsList, "sectorList");
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in onSectorsChange",
          err.toString(),
          "onSectorsChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onBookingClassChange(pBookingClassList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onBookingClassChange");
        this.handleDropDownOptions(pBookingClassList, "bookingClassList");
          this.classAlert=null 
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in onBookingClassChange",
          err.toString(),
          "onBookingClassChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    addBookingClass(pClassName) {
      try {
        if (BaseConfiguration.isDebug) console.log("addBookingClass");

        if (pClassName && this.lsClasses && this.lsClasses.length != null) {
          if((/^[A-Za-z_ ]+$/g.test(pClassName)))
           {
             this.classAlert=null
          this.lsClasses.push(pClassName.toString().toUpperCase());
          this.pricing.bookingClassList.push(pClassName.toString().toUpperCase());
           }
           else{
             this.classAlert='Use only alphabets'
           }
        } else {
          throw "failed to add new booking class";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in addBookingClass",
          err.toString(),
          "addBookingClass",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async updatePricing() {
      let retValue;

      try {
        if (BaseConfiguration.isDebug) console.log("updatePricing");
        let pricingReq;

        pricingReq = apiUpdateSimplePricing.buildRequest(
          this.getPricingRequest(cloneDeep(this.pricing), true)
        );

        if (pricingReq != null) {
          let pricingRes = await apiUpdateSimplePricing.getResponse(pricingReq);
          if (VALIDATE_SUCCESS_RES(pricingRes)) {
            retValue = pricingRes.data.data;
          } else {
            let error = getErrorMessage(pricingRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in updatePricing",
          err.toString(),
          "updatePricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    navToManagePricing() {
      try {
        if (BaseConfiguration.isDebug) console.log("navToManagePricing");

        goBack();
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in navToManagePricing",
          err.toString(),
          "navToManagePricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async createPricing() {
      let retValue;

      try {
        if (BaseConfiguration.isDebug) console.log("createPricing");
        let pricingReq;

        pricingReq = apiCreateSimplePricing.buildRequest(
          this.getPricingRequest(cloneDeep(this.pricing))
        );

        if (pricingReq != null) {
          let pricingRes = await apiCreateSimplePricing.getResponse(pricingReq);
          if (VALIDATE_SUCCESS_RES(pricingRes)) {
            retValue = pricingRes.data.data;
          } else {
            let error = getErrorMessage(pricingRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in createPricing",
          err.toString(),
          "createPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getPricingRequest(pPricing, isUpdate) {
      let pricingRequest;
      try {
        if (BaseConfiguration.isDebug) console.log("getPricingRequest");

        let isValidPricing =
          pPricing &&
          pPricing.applicableTo &&
          pPricing.pricingType &&
          pPricing.currencies &&
          pPricing.name;

        if (
          this.GET_SEL_TIER_NAME &&
          this.GET_SEL_TIER_NAME.tierid != null &&
          isValidPricing
        ) {
          pricingRequest = {
            tierId: this.GET_SEL_TIER_NAME.tierid,
             travelPeriodFrom: pPricing.travelPeriodFrom,
            travelPeriodTo: pPricing.travelPeriodTo, 
            airlines: pPricing.airlines
              .map((airline) => airline.airline_code)
              .filter((val) => val != null),
           
            sectorList: pPricing.sectorList
              .map((sector) => sector.value)
              .filter((val) => val != DEFAULT_DROPDOWN_STATUS.ALL),
            bookingClassList: pPricing.bookingClassList.filter(
              (val) => val != DEFAULT_DROPDOWN_STATUS.ALL
            ),
            upDown: pPricing.upDown,
            applicableTo: pPricing.applicableTo.value,
            pricingType: pPricing.pricingType.value,
            currencies: pPricing.currencies,
            name: pPricing.name,
          };

          if (pricingRequest && pricingRequest.currencies.length) {
            pricingRequest.currencies.forEach((curr) => {
              curr.value = parseFloat(curr.value);
            });
          }

          pricingRequest.airlines = pricingRequest.airlines.length
            ? pricingRequest.airlines
            : null;
          pricingRequest.sectorList = pricingRequest.sectorList.length
            ? pricingRequest.sectorList
            : null;
          pricingRequest.bookingClassList = pricingRequest.bookingClassList
            .length
            ? pricingRequest.bookingClassList
            : null;

          if (isUpdate) pricingRequest.markupId = pPricing.markupId;
        } else throw "invalid tier id or pricing";
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in getPricingRequest",
          err.toString(),
          "getPricingRequest",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return pricingRequest;
    },

    async onPricingFormSubmit() {
      try {
        if (BaseConfiguration.isDebug) console.log("onPricingFormSubmit");
        let createStatus;
        let updateStatus;
           this.classAlert=null 
        if (this.selectedPricing) {
          updateStatus = await this.updatePricing();
        } else {
          createStatus = await this.createPricing();
        }

        if (
          (createStatus && createStatus.markupId) ||
          (updateStatus && updateStatus.isUpdated)
        ) {
          this.toggleAlertModal();
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in onPricingFormSubmit",
          err.toString(),
          "onPricingFormSubmit",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    findALL(pOptionsList) {
      let retValue = false;
      try {
        if (BaseConfiguration.isDebug) console.log("findALL");

        if (pOptionsList && pOptionsList.length) {
          retValue = pOptionsList.find((val) => {
            if (val == DEFAULT_DROPDOWN_STATUS.ALL) {
              return true;
            } else if (val.constructor == Object) {
              return (
                Object.keys(val).some(
                  (key) => val[key] == DEFAULT_DROPDOWN_STATUS.ALL
                ) && val.canRemove
              );
            }
          });
        } else {
          throw "invalid options";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in findALL",
          err.toString(),
          "findALL",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    handleDropDownOptions(pSelValue, pTargetValue) {
      try {
        if (BaseConfiguration.isDebug) console.log("handleDropDownOptions");

        if (pSelValue && !Array.isArray(pSelValue)) {
          pSelValue = [pSelValue];
          this.pricing[pTargetValue] = pSelValue;
        }
        if (pSelValue && pSelValue.length) {
          let allStatus = this.findALL(pSelValue);
          if (allStatus) {
            this.pricing[pTargetValue] = [allStatus];
            pSelValue = [allStatus];
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in handleDropDownOptions",
          err.toString(),
          "handleDropDownOptions",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assignSectorsClasses(airlineSectorClassesRes) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignSectorsClasses");

        if (airlineSectorClassesRes) {
          this.lsSectors = airlineSectorClassesRes.sectors
            ? airlineSectorClassesRes.sectors
            : [];

          this.lsClasses = airlineSectorClassesRes.classes
            ? airlineSectorClassesRes.classes
            : [];
        } else {
          this.lsSectors = [];
          this.lsClasses = [];
        }
        if (this.lsSectors && this.lsSectors.length) {
          this.lsSectors.unshift({
            value: DEFAULT_DROPDOWN_STATUS.ALL,
            canRemove: true,
          });
        }
        if (this.lsClasses && this.lsClasses.length) {
          this.lsClasses.unshift(DEFAULT_DROPDOWN_STATUS.ALL);
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.filename,
          "error in assignSectorsClasses",
          err.toString(),
          "assignSectorsClasses",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async onAirlineChange(pAirLine) {
      try {
        if (BaseConfiguration.isDebug) console.log("onAirlineChange.");

        this.handleDropDownOptions(pAirLine, "airlines");
        pAirLine = this.pricing.airlines;

        if (pAirLine && pAirLine.length) {
          let airlineCodes = pAirLine
            .map((airline) => airline.airline_code)
            .filter((val) => val != null);
          let airlineSectorClassesRes = await this.getSectorsClasses(
            airlineCodes && airlineCodes.length ? airlineCodes : null
          );
          this.assignSectorsClasses(airlineSectorClassesRes);
        } else {
          throw "invalid airline Selection";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in onAirlineChange.",
          err.toString(),
          "onAirlineChange.",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    onPricingApplicableToChange(pType) {
      if (BaseConfiguration.isDebug) console.log("onPricingApplicableToChange");
      try {
        this.pricing.applicableTo = pType;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in onPricingApplicableToChange",
          err.toString(),
          "onPricingApplicableToChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    getRules() {
      if (BaseConfiguration.isDebug) console.log("getRules");
      let rules;
      // let rule1 = "required|onlynumber|notValidNum|";
      let rule1 = "required|onlynumber|";

      let rule2 = "max_val:100";
      rules =
        this.pricing.pricingType.value == PRICING_VALUE.PERCENTAGE
          ? rule1 + rule2
          : rule1;
      return rules;

      // ("_required|no_space|no_special_char|only_numbers|min_val:0|"+
      // this.pricing.pricingType.name=="Percentage"?"max_val:100":"")
    },

    async getCurrencyList(pSCurrencyLs) {
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencyList");
        let retValue;

        let currencyRequest = apiGetOrgCurrencyLs.buildRequest();

        if (currencyRequest) {
          let currencyResponse;
          if (
            pSCurrencyLs &&
            pSCurrencyLs.data &&
            pSCurrencyLs.data.data &&
            pSCurrencyLs.data.data[0] &&
            pSCurrencyLs.data.data[0].currency_code &&
            pSCurrencyLs.data.data[0].currency_code.constructor == String
          ) {
            //this was called in sidebar this.GET_ORG_CURRENCY_RES //temp
            currencyResponse = JSON.parse(
              JSON.stringify(this.GET_ORG_CURRENCY_RES)
            );
          } else {
            currencyResponse = await apiGetOrgCurrencyLs.getResponse(
              currencyRequest
            );
          }
          if (VALIDATE_SUCCESS_RES(currencyResponse)) {
            retValue = JSON.parse(JSON.stringify(currencyResponse.data.data));
          } else {
            // this.showAlert = true;

            let error = getErrorMessage(currencyResponse);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
        return retValue;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getCurrencyList",
          err.toString(),
          "getCurrencyList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getCurrencies(currencyList) {
      try {
        if (BaseConfiguration.isDebug) console.log("getCurrencies");
        let currList = [];
        if (currencyList && currencyList.length)
          for (let cList = 0; cList < currencyList.length; cList++) {
            const cListItem = currencyList[cList];

            let currObj = {
              value: 0,
              currency: cListItem.currency_code,
            };
            currList.push(currObj);
          }
        return currList;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in getCurrencies",
          err.toString(),
          "getCurrencies",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      // return retValue;
    },

    getPricingApplicableList() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getPricingApplicableList.");
        retValue = [
          {
            name: this.$t("createPricing.PERPAX"),
            value: PRICING_VALUE.PER_PASSENGER,

            code: "1",
          },
          {
            name: this.$t("createPricing.PERBOOK"),
            value: PRICING_VALUE.PER_BOOKING,

            code: "2",
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in getPricingApplicableList.",
          err.toString(),
          "getPricingApplicableList.",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    getPricingTypes() {
      let retValue = [];
      try {
        if (BaseConfiguration.isDebug) console.log("getPricingTypes");

        retValue = [
          {
            name: this.$t("createPricing.PERC"),
            value: PRICING_VALUE.PERCENTAGE,
            code: "1",
          },
          {
            name: this.$t("createPricing.FIX"),
            value: PRICING_VALUE.FIXED_AMOUNT,
            code: "2",
          },
        ];
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in getPricingTypes",
          err.toString(),
          "getPricingTypes",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
    async getAirLineList() {
      let returnValue = [];
      try {
        let airLineRequest = apiGetAirline.buildRequest();
        if (airLineRequest) {
          let airLineResponse = await apiGetAirline.getResponse(airLineRequest);

          if (VALIDATE_SUCCESS_RES(airLineResponse)) {
            returnValue = airLineResponse.data.data;
            if (returnValue && returnValue.length) {
              returnValue.unshift({
                airline_code: null,
                airline_name: DEFAULT_DROPDOWN_STATUS.ALL,
                canRemove: true,
              });
            }
          } else {
            let error = getErrorMessage(airLineResponse);
            let isJwt = handleJWT(error);
            if (!isJwt) {
              getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }

        return returnValue;
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in getAirLineList",
          err.toString(),
          "getAirLineList",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    onChangeDate(pDateList) {
      try {
        if (BaseConfiguration.isDebug) console.log("onChangeDate");

        if (pDateList) {
          this.pricing.travelPeriodFrom = this.$options.filters.formatDate(
            pDateList[0]._d,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
          this.pricing.travelPeriodTo = this.$options.filters.formatDate(
            pDateList[1]._d,
            DATE_TIME_FORMAT.API_DATE_FORMAT
          );
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in onChangeDate",
          err.toString(),
          "onChangeDate",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
    async getSectorsClasses(pAirLineCodes) {
      let returnValue;
      if (BaseConfiguration.isDebug) console.log("getSectorsClasses");
      try {
        let pricingSectorsReq;

        pricingSectorsReq = apiGetPricingSectorsClasses.buildRequest(
          pAirLineCodes
        );

        if (pricingSectorsReq != null) {
          let pricingSectorsRes = await apiGetPricingSectorsClasses.getResponse(
            pricingSectorsReq
          );
          if (VALIDATE_SUCCESS_RES(pricingSectorsRes)) {
            returnValue = pricingSectorsRes.data.data;
          } else {
            let error = getErrorMessage(pricingSectorsRes);

            let isJwt = handleJWT(error);
            if (!isJwt) {
              getErrorAlertValue(error);
            }
          }
        } else {
          throw "invalid request";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in getSectorsClasses",
          err.toString(),
          "getSectorsClasses()",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }

      return returnValue;
    },

    onPricingTypeChange(pNewValue) {
      if (BaseConfiguration.isDebug) console.log("onPricingTypeChange");

      try {
        this.pricing.pricingType =
          pNewValue && pNewValue.value ? pNewValue : null;
        //  this.pricing.currencies = JSON.parse(JSON.stringify(this.currencyList));
        if (this.pricing.pricingType) {
          this.pricing.applicableTo = this.lsPricingApplicables.find((type) => {
            if (this.pricing.pricingType.value == PRICING_VALUE.PERCENTAGE)
              return type.value == PRICING_VALUE.PER_BOOKING;
            else return type.value == PRICING_VALUE.PER_PASSENGER;
          });
        } else {
          throw "invalid pricing type";
        }
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_PRICING,
          "error in onPricingTypeChange",
          err.toString(),
          "onPricingTypeChange",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async initData() {
      try {
        if (BaseConfiguration.isDebug) console.log("initData");
        this.lsAirlines = await this.getAirLineList();

        this.lsPricingTypes = this.getPricingTypes();

        this.lsPricingApplicables = this.getPricingApplicableList();
        this.currencyList = this.getCurrencies(
          await this.getCurrencyList(cloneDeep(this.GET_ORG_CURRENCY_RES))
        );
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in initData",
          err.toString(),
          "initData",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async assignDefaultPricing() {
      try {
        if (BaseConfiguration.isDebug) console.log("assignDefaultPricing");
        this.pricing.currencies = cloneDeep(this.currencyList);
        this.pricing.pricingType = this.lsPricingTypes.find(
          (type) => type.value == PRICING_VALUE.PERCENTAGE
        );

        this.onPricingTypeChange(this.pricing.pricingType);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in assignDefaultPricing",
          err.toString(),
          "assignDefaultPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    async assignAirlineDetails(pAirLineCodes, pSelectedPricing) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignAirlineDetails");
        if (this.lsAirlines && this.lsAirlines.length) {
          this.pricing.airlines = pAirLineCodes
            ? this.lsAirlines.filter(
                (airline) => pAirLineCodes.includes(airline.airline_code)
                //to find status All in list
              )
            : [this.lsAirlines[0]];

          await this.onAirlineChange(this.pricing.airlines);

          //assign Booking classes
          if (this.lsClasses && this.lsClasses.length)
            this.pricing.bookingClassList = cloneDeep(
              pSelectedPricing.bookingclassList
                ? pSelectedPricing.bookingclassList
                : [this.lsClasses[0]]
            );

          //assign sectors list
          if (this.lsSectors && this.lsSectors.length)
            this.pricing.sectorList = pSelectedPricing.sectorList
              ? this.lsSectors.filter((sector) =>
                  pSelectedPricing.sectorList.includes(sector.value)
                )
              : [this.lsSectors[0]];
        } else throw "empty airlines";
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in assignAirlineDetails",
          err.toString(),
          "assignAirlineDetails",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },

    assignSelectedPricing(pSelPricing) {
      try {
        if (BaseConfiguration.isDebug) console.log("assignSelectedPricing");

        this.pricing = {
          markupId: pSelPricing.markupId,
          tierId: null,
          airlines: [],
          name: pSelPricing.name,
          travelPeriodFrom: pSelPricing.travelPeriodFrom,
          travelPeriodTo: pSelPricing.travelPeriodTo,
          sectorList: [],
          bookingClassList: [],
          upDown: "UP",
          applicableTo: null,
          pricingType: this.lsPricingTypes.find(
            (type) => type.value == pSelPricing.pricingType
          ),
          currencies: pSelPricing.b2bPricingMarkupCurrencies,
        };

        if (this.pricing.currencies && this.pricing.currencies.length) {
          this.pricing.currencies.forEach((curr) => {
            curr.value = parseFloat(curr.value);
          });
        }

        this.onPricingTypeChange(this.pricing.pricingType);
        this.assignAirlineDetails(pSelPricing.airlines, pSelPricing);
      } catch (err) {
        let body = Logger.buildRequest(
          FILE_NAME.CREATE_SIMPLE_PRICING,
          "error in assignSelectedPricing",
          err.toString(),
          "assignSelectedPricing",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
    },
  },

  async created() {
    try {
      if (BaseConfiguration.isDebug) console.log("created");

      await this.initData();

      if (this.selectedPricing) {
        this.assignSelectedPricing(this.selectedPricing);
      } else {
        await this.assignDefaultPricing();
      }
    } catch (err) {
      let body = Logger.buildRequest(
        FILE_NAME.CREATE_SIMPLE_PRICING,
        "error in created",
        err.toString(),
        "created",
        LOG_TYPE.ERROR
      );
      Logger.getResponse(body);
    }
  },

  beforeCreate() {
    addClassToBody(COMPONENT_NAME.CREATE_PRICING);
  },

  beforeDestroy() {
    removeClassBody();
  },
};
</script>

<style></style>
